import { useMemo, useState } from 'react';
import { Typography } from 'seagull';
import { WideArrowDownward, WideArrowUpward } from 'seagull/icons';
import { Collapse } from '@material-ui/core';
import { splitServices } from "./StatementOfWork.utils";
import styles from "./StatementOfWork.module.scss";
import AgreementServiceInstance from "./AgreementServiceInstance";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const toggleIconSize = 18;
export default function StatementOfWork(props) {
  const {
    services,
    isVendor,
    qboClasses,
    serviceDetailsProps
  } = props;
  const [activeServices, inactiveServices] = useMemo(() => splitServices(services, isVendor), [isVendor, services]);
  const [stoppedOrCompletedServicesShown, setStoppedOrCompletedServicesShown] = useState(activeServices.length === 0);
  const renderService = addToIdx => (service, idx) => /*#__PURE__*/_jsx(AgreementServiceInstance, {
    qboClasses: qboClasses,
    serviceDetailsProps: serviceDetailsProps,
    service: service,
    idx: idx + addToIdx
  }, service.id);
  return /*#__PURE__*/_jsxs("section", {
    className: styles.root,
    children: [activeServices.map(renderService(0)), inactiveServices.length > 0 && /*#__PURE__*/_jsxs("div", {
      className: styles.stoppedOrCompletedServicesContainer,
      children: [/*#__PURE__*/_jsxs("button", {
        className: styles.header,
        "data-testid": "toggle-stopped-completed-services",
        onClick: () => setStoppedOrCompletedServicesShown(!stoppedOrCompletedServicesShown),
        children: [/*#__PURE__*/_jsx(Typography, {
          children: "Stopped and completed services"
        }), /*#__PURE__*/_jsx(Typography, {
          skin: "secondary",
          children: stoppedOrCompletedServicesShown ? /*#__PURE__*/_jsx(WideArrowUpward, {
            height: toggleIconSize,
            width: toggleIconSize
          }) : /*#__PURE__*/_jsx(WideArrowDownward, {
            height: toggleIconSize,
            width: toggleIconSize
          })
        })]
      }), /*#__PURE__*/_jsx(Collapse, {
        in: stoppedOrCompletedServicesShown,
        children: /*#__PURE__*/_jsx("div", {
          className: styles.collapseContainer,
          children: inactiveServices.map(renderService(activeServices.length))
        })
      })]
    })]
  });
}